module.exports = "<p>\r\n  print-label works!\r\n</p>\r\n"